import Factory from '../../common/di/factory';


class BookingServiceFactory extends Factory {}

export default BookingServiceFactory;
